import React, { Component } from "react";
import { nanoid } from "nanoid";
import SectionHeader from "../sectionHeader/sectionHeader";
import TabContent from "../tabContent/tabContent";

class Features extends Component {
  constructor(props) {
    super();
    this.state = {
      features: [
        "Interactive courses",
        "Microlearning",
        "Fun Assessments",
        "Real-World Cases",
        "Quizzes",
      ],
      active: "Interactive courses",
      tabs: {
        "Interactive courses": {
          image: "interactivecourses",
          title: "Engage Your Mind with Interactive Learning",
          featureDesc:
            "Elevate your skills through hands-on experience with Duomly’s captivating interactive courses. Designed for busy learners, our courses fit into your dynamic lifestyle, offering punchy, practical knowledge on the go.",
          featuresList: [
            "Bite-sized lessons for quick knowledge absorption",
            "Engaging quizzes and interactive challenges",
            "Diverse topics from IT & AI to Career Development",
            "Storytelling approach for memorable learning",
            "Progress tracking to celebrate your achievements",
          ],
        },
        "Fun Assessments": {
          image: "funassesments",
          title: "Learn and Laugh with Fun Assessments",
          featureDesc:
            "Uncover the joy of progress with Duomly's delightful assessments led by our friendly Panda! Test your knowledge and reinforce your learning with enjoyable and dynamic exercises designed to make education entertaining.",
          featuresList: [
            "Variety of fun exercises with instant feedback",
            "Meet our cheerful Panda guide in each test",
            "Lighthearted approach to serious education",
          ],
        },
        "Real-World Cases": {
          image: "realworldcases",
          title: "Master Skills with Real-World Cases",
          featureDesc:
            "Bridge theory and practice with Duomly's real-world case studies. Learn to navigate actual professional scenarios, giving you the hands-on experience to apply your knowledge confidently in your career.",
          featuresList: [
            "Scenario-based learning for practical application",
            "Solutions-oriented approach to problem-solving",
            "Interactive examples that mirror workplace tasks",
            "Practical tasks to enhance understanding",
          ],
        },
        Quizzes: {
          image: "quizzes",
          title: "Boost Your Expertise with Engaging Quizzes",
          featureDesc:
            "Test your knowledge and solidify your learning with our diverse range of quizzes. Each interactive challenge is designed to reinforce your understanding and help you track your progress in a stimulating way.",
          featuresList: [
            "Interactive quizzes tailored to each course",
            "Real-time feedback to guide your learning path",
            "Thought-provoking questions for deeper insight",
            "Fun, competitive elements to keep you motivated",
          ],
        },
        Microlearning: {
          image: "minigames",
          title: "Advance Quickly with Microlearning",
          featureDesc:
            "Maximize your learning efficiency with Duomly's microlearning approach. Focused, bite-sized lessons fit into even the busiest schedules, making skill advancement achievable for everyone.",
          featuresList: [
            "Short, focused lessons for rapid comprehension",
            "Condensed knowledge that fits into your day",
            "Learn at your pace, anytime, anywhere",
            "Quick wins to maintain motivation and interest",
          ],
        },
      },
    };
  }

  handleOnClick(feature) {
    this.setState({ active: feature });
  }

  render() {
    return (
      <section id="features">
        <div className="container">
          <SectionHeader
            title="Features"
            subtitle="At "
            greenText="Duomly "
            subtitleFinish="you can find a lot of useful features, which will help you while your learning adventure!"
          />
          <div className="tabs">
            <div className="buttons flex flex-wrap justify-center">
              {this.state.features.map((feature) => {
                return (
                  <a
                    onClick={() => this.handleOnClick(feature)}
                    className={`rounded-xl px-4 py-2.5 border-2 border-gray-200 mx-2 cursor-pointer hover:bg-gray-400 hover:text-white hover:border-gray-400 mb-4 lg:mb-0 ${
                      feature === this.state.active
                        ? "border-green-500 text-green-500 "
                        : "text-gray-400"
                    }`}
                    key={nanoid()}
                  >
                    {feature}
                  </a>
                );
              })}
            </div>
            <TabContent
              image={this.state.tabs[this.state.active].image}
              title={this.state.tabs[this.state.active].title}
              featureDesc={this.state.tabs[this.state.active].featureDesc}
              featuresList={this.state.tabs[this.state.active].featuresList}
            />
          </div>
        </div>
        <div className="wave"></div>
      </section>
    );
  }
}

export default Features;
